import type { FormValues } from './appointment-outcome-modal.types';

export const ARRIVAL_STATUS_OPTIONS = [
  { label: 'On Time', key: 'onTime' },
  { label: 'Arrived Late', key: 'arrivedLate' },
  { label: 'Never Arrived', key: 'neverArrived' },
];

export const initialValues: FormValues = {
  arrivalStatus: '',
  resolved: '',
  workRating: undefined,
  workComments: '',
  noLongerNeedsVisit: false,
  requestorAvailability: [],
};

export function validate(values: FormValues) {
  const errors: Partial<Record<keyof FormValues, string>> = {};

  if (!values.arrivalStatus) {
    errors.arrivalStatus = 'Required';
    return errors;
  }

  const isResolvableBranch =
    values.arrivalStatus === 'onTime' || values.arrivalStatus === 'arrivedLate';
  const isNeverArrived = values.arrivalStatus === 'neverArrived';

  if (isResolvableBranch && values.resolved === '') {
    errors.resolved = 'Required';
    return errors;
  }

  if (isResolvableBranch && values.resolved === true) {
    if (!values.workRating) {
      errors.workRating = 'Please select a rating';
    }
    return errors;
  }

  const isInReschedulePath =
    (isResolvableBranch && values.resolved === false) || isNeverArrived;

  if (isInReschedulePath && !values.noLongerNeedsVisit) {
    const daysWithTimes = values.requestorAvailability.filter(
      (d) => d.times.length > 0,
    );
    if (daysWithTimes.length < 3) {
      errors.requestorAvailability = 'Please select at least 3 different days';
    }
  }

  return errors;
}
